<template>
    <div v-if="customFields.length > 0">
        <h5 v-if="!disabledTitle">Thông tin tuỳ biến</h5>
        <div class="alert alert-danger" v-if="errorTxt">{{errorTxt}}</div>

        <div v-if="customFields && customFields.length" class="title-template-table table-responsive">
            <table class="table table-hover table-striped b-table-select-single">
                <thead>
                    <tr>
                        <th>Chỉ tiêu</th>
                        <th class="text-center">Đơn vị tính</th>
                        <th class="text-center">Kết quả quan trắc</th>
                        <th class="text-center">Số đo</th>
                        <th class="text-center">Quy chuẩn (QCVN)</th>
                    </tr>
                </thead> 
                <tbody>
                    <tr v-for="field in customFields" :key="field.id">
                        <td v-if="field.types.includes(typeMonitoring)">{{field.title}} <span v-if='field.required' class='text-danger' >*</span></td>
                        <td v-if="field.types.includes(typeMonitoring)" class="text-center">{{field.unit}} </td>
                        <td v-if="field.types.includes(typeMonitoring)">
                            <form-select v-if='customFieldsModel[field.id]' type="text" placeholder="" class='mb-0'
                            :model="customFieldsModel[field.id]" attribute="result" :errors="fieldErrors" :error-only="true" :close-on-select='true' :options="typeOptions" />
                        </td>
                        <td v-if="field.types.includes(typeMonitoring)">
                            <form-input v-if='customFieldsModel[field.id]' type="text" placeholder="Nhập số đo" class='mb-0'
                            :model="customFieldsModel[field.id]" attribute="measure" :errors="fieldErrors" :error-only="true" />
                        </td>
                        <td v-if="field.types.includes(typeMonitoring)" class="text-center">
                            <span v-for="data in dataField" :key="data.id"> {{ data.target_id === field.id ? data.uni : '' }}</span>
                        </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            model: Object,
            attribute: {
                type: String,
                default: 'customFields'
            },
            disabledTitle: {
                type: Boolean,
                default: true
            },
            customFields: Array,
            type: String,
            errors: Object,
            typeMonitoring: Number, 
            dataField: Array,
        },
        data() {
            return {
                customFieldsModel: {},
                fieldErrors: {},
                errorTxt: null,
                typeOptions: [
                    {value: 1, text: "Phát hiện (PH)"},
                    {value: 2, text: "Không phát hiện (KPH)"}
                ]
            };
        },
        watch: {
            customFieldsModel: {
                handler() {
                    let model = [];
                    let errors = {};
                    this.customFields.forEach(field => {
                        if (this.customFieldsModel[field.id]) {
//                            if (val && val.length) {  
                            model.push(this.customFieldsModel[field.id]);
//                            } else {
//                                if (field.required) {
//                                    errors[field.key] = ["Bắt buộc nhập"];
//                                }
//                            }
                        } else {
                            if (field.required) {
                                errors[field.id] = ["Bắt buộc nhập"];
                            }
                        }
                    });
                    if (Object.keys(errors).length > 0) {
                        this.fieldErrors = errors;
                        this.model[this.attribute] = null;
                    } else {
                        this.model[this.attribute] = model;
                    }
                }, deep: true
            },
            errors(val) {
                if (val && Object.keys(val).length) {
                    Object.keys(val).forEach(key => {
                        if (key === this.attribute) {
                            this.errorTxt = val[key].join(";");
                        }
                    });
                }
            }
        },
        methods: {
            loadModel() {
                let model = {};
                this.customFields.forEach(field => {
                    let customField;
                    if (this.model[this.attribute]) {
                        customField = this.model[this.attribute].find(v => v.target_id === field.id);
                    }
                    if (customField) {
                        model[field.id] = customField;
                    } else {
                        model[field.id] = {
                            target_id: field.id,
                            uni: null,
                        };
                    }
                });
                this.customFieldsModel = model;
            }
        },
        mounted() {
            this.loadModel();
        }
    }
</script>
